<template>
  <div>
    <div class="header-main">
      <img src="../assets/image/logo1.png" alt="" @click="toHome" />
      <van-search
        background="#515A6E"
        v-model="seachVal"
        placeholder="请输入资源名称"
        @search="onSearch"
      />
      <div class="icons" @click="isNav" v-if="isShows">
        <img src="../assets/image/tolist.png" alt="" />
      </div>
      <div class="icons" v-else></div>
    </div>
    <div class="mask" v-show="isShow" @click="closeNav">
      <ul class="mask-main" :class="{ lsit: isanimate == true }" @click.stop="">
        <li><a href="http://www.simaxian.com" style="color:white;">首页</a></li>
        <router-link v-if="userInfo.token == undefined" tag="li" to="/login"
          >登录</router-link
        >
        <li v-else @click="exit">注销</li>
      </ul>
    </div>
  </div>
</template>

<script>
import caseApi from "@/api/caseApi";
export default {
  name: "Header",
  props: ["isShows"],
  data() {
    return {
      seachVal: "",
      userInfo: {},
      isShow: false,
      isanimate: false,
    };
  },
  created() {
    var tempinfo = JSON.parse(localStorage.getItem("userInfo"));
    if (tempinfo != null) this.userInfo = tempinfo;
  },
  methods: {
    onSearch() {
      console.log(this.seachVal);
      let params = {
        pageindex: 1,
        pagesize: 4,
        key: this.seachVal,
        doctype: ".mp4,.doc,.docx,.ppt,.pptx,.pdf,.txt,.xls,.xlsx",
        dockind: -1,
        userkind: -1,
        sort: -1,
        modelid: 0,
      };
      caseApi.getVideo(params).then((res) => {
        if (res.ResultType == 0) {
          res.Data.Items.forEach((item) => {
            if (item.ImageUrl == "image/addbg.png") {
              if (item.Type == ".mp4") {
                item.ImageUrl = require("@/assets/image/mrvideo.png");
              } else if (item.Type == ".doc" || item.Type == ".docx") {
                item.ImageUrl = require("@/assets/image/mrdoc.png");
              } else if (item.Type == ".ppt" || item.Type == ".pptx") {
                item.ImageUrl = require("@/assets/image/mrppt.png");
              } else if (item.Type == ".pdf") {
                item.ImageUrl = require("@/assets/image/mrpdf.png");
              } else if (item.Type == ".txt") {
                item.ImageUrl = require("@/assets/image/mrtxt.png");
              } else if (item.Type == ".xls" || item.Type == ".xlsx") {
                item.ImageUrl = require("@/assets/image/mrxls.png");
              }
            }
          });
          let list = res.Data;
          localStorage.setItem("list", JSON.stringify(list));
          localStorage.setItem("key", this.seachVal);
          this.$router.push({ path: "/caseList" });
        }
      });
    },
    isNav() {
      this.isShow = true;
      setTimeout(() => {
        this.isanimate = true;
      }, 100);
    },
    closeNav() {
      (this.isShow = false), (this.isanimate = false);
    },
    exit() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      this.userInfo = {};
      window.location.reload();
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped lang="scss">
body,
html {
  width: 100%;
  height: 100%;
}
.header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background: #515a6e;
  height: 60px;
  img {
    width: 50px;
    height: 30px;
  }
  .icons {
    img {
      width: 30px;
      height: 30px;
    }
  }
}
.mask {
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  .mask-main {
    position: absolute;
    right: 0;
    top: 0;
    width: 0%;
    height: 100%;
    background: #999;
    transition: all ease 0.3s;
    z-index: 999;
    li {
      line-height: 60px;
      border-bottom: 1px solid #fff;
      color: #fff;
    }
  }
  .lsit {
    width: 40%;
  }
}
</style>
